import React, { useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import {
    Provider as ReduxProvider,
    ReactReduxContext,
    useDispatch,
    useSelector,
} from "react-redux";

import { USER_ACTION_STATE } from "lib/constants";
import RetainCrossSellModal from "portal/Retain/RetainCrossSellModal";
import { showModal } from "redux/ws/actions";

const ANNOUNCEMENT_COMPONENT_MAP = {
    [USER_ACTION_STATE.PULSE_INTRO_MODAL_ANNOUNCEMENT]: {
        Component: RetainCrossSellModal,
        isModal: true,
    },
};

const Announcements = () => {
    const dispatch = useDispatch();
    const announcement = useSelector((state) => state.ws.announcement);
    const { store } = useContext(ReactReduxContext);

    useEffect(() => {
        if (
            !announcement ||
            !announcement.action_state ||
            !ANNOUNCEMENT_COMPONENT_MAP[announcement.action_state]
        ) {
            return;
        }

        const {
            Component,
            getMountPoint = () => document.body,
            isModal,
            timeout,
        } = ANNOUNCEMENT_COMPONENT_MAP[announcement.action_state];

        setTimeout(() => {
            if (isModal) {
                dispatch(showModal(<Component {...announcement} />));
            } else {
                const div = document.createElement("div");
                const mountPoint = getMountPoint();
                if (mountPoint) {
                    mountPoint.appendChild(div);

                    ReactDOM.render(
                        <ReduxProvider store={store}>
                            <Component {...announcement} />
                        </ReduxProvider>,
                        div,
                    );
                }
            }
        }, timeout || 1000);
    }, []);

    return null;
};

export default Announcements;
